import React from 'react';
import Image from '../assets/banner.png';
import { FaGithub, FaYoutube, FaLinkedin } from 'react-icons/fa';
import { TypeAnimation } from 'react-type-animation';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const Banner = () => {
  return (
    <section className='min-h-[85vh] lg:min-h-[78vh] flex items-center' id='home'>
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>
          <div className='flex-1 text-center font-secondary lg:text-left'>
            <motion.h1 variants={fadeIn('up', 0.3)} initial="hidden" whileInView={'show'} viewport={{once: false, amount:0.7}} className='text-[50px] font-bold leading-[0.8] lg:text-[90px]'>
              LETÍCIA<span> OLIVEIRA</span>
            </motion.h1>
            <motion.div
            variants={fadeIn('up', 0.4)} initial="hidden" whileInView={'show'} viewport={{once: false, amount:0.7}}
            className='mb-4 text-[30px] lg:text-[50px] font-secondary font-semibold uppercase leading-[1]'>
              <span className='text-white mr-4'>Desenvolvedora</span>
              <TypeAnimation sequence={[
                'Back-end',
                2000,
                'Front-end',
                2000,
                'Full Stack',
                2000
              ]} 
              speed={50}
              className='text-accent'
              wrapper='span'
              repeat={Infinity}
              />
            </motion.div>
            <motion.p variants={fadeIn('up', 0.6)} initial="hidden" whileInView={'show'} viewport={{once: false, amount:0.7}}className='mb-8 max-w-lg mx-auto lg:mx-0'>Estudante de Sistemas de Informação formada pelo Bootcamp "Pessoa Desenvolvedora Web Full Stack" da Generation Brasil e Estag Cluster Tecnologia J6 no Santander.</motion.p>
            <motion.div variants={fadeIn('up', 0.3)} initial="hidden" whileInView={'show'} viewport={{once: false, amount:0.7}}className='flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0'>
              <a href='https://www.youtube.com/watch?v=bbxvICmrqOY&t=4s' target='blank'>
              <button className='btn btn-lg'>Me conheça melhor!</button>
              </a>
              <a href='https://www.linkedin.com/in/leticiaj/' target="_blank" className='text-gradient btn-link'>Meu LinkedIn</a>
            </motion.div>
            <motion.div variants={fadeIn('up', 0.7)} initial="hidden" whileInView={'show'} viewport={{once: false, amount:0.7}}className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0'>
              <a href="https://www.youtube.com/watch?v=bbxvICmrqOY&t=4s&pp=ygUWbGV0aWNpYSBvbGl2ZWlyYSBwaXRjaA%3D%3D" target='blank'>
                <FaYoutube />
              </a>
              <a href="https://github.com/leticiaoj" target='blank'>
                <FaGithub />
              </a>
              <a href="https://www.linkedin.com/in/leticiaj/" target='blank'>
                <FaLinkedin />
              </a>
            </motion.div>
          </div>
          <motion.div variants={fadeIn('down', 0.5)} initial="hidden" whileInView={'show'} className='hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px]'>
            <img src={Image} alt='' />
          </motion.div>
        </div>
      </div>
    </section>
  )
};

export default Banner;
